import { IAiService, IExternalSystemRegistry, IExternalSystemService } from "../../../domain/externalSystem";
import { ExternalSystemService } from "..";
import { AiService } from "./AiService";

export class ExternalSystemRegistry implements IExternalSystemRegistry {
  constructor(private _getToken: () => string) {
  }

  getExternalSystemService(): IExternalSystemService {
    return new ExternalSystemService(this._getToken);
  }

  getAiService(): IAiService {
    return new AiService(this._getToken);
  }
}
